import { render, staticRenderFns } from "./print2.vue?vue&type=template&id=2f2bbdb6&scoped=true&"
import script from "./print2.vue?vue&type=script&lang=js&"
export * from "./print2.vue?vue&type=script&lang=js&"
import style0 from "./print2.vue?vue&type=style&index=0&id=2f2bbdb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2bbdb6",
  null
  
)

export default component.exports